import * as dayjs from 'dayjs'

function underline(s: string): string {
    return s.replace(/_([a-z])/g, function (all, letter) {
        return letter.toUpperCase();
    });
}

function humpline(s: string): string {
    return s.replace(/([A-Z])/g, '_$1').toLowerCase();
}

function jsonNewline(obj: any): void {
    if (Array.isArray(obj)) {
        obj.forEach(function (v) {
            jsonNewline(v);
        });
    } else if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach(function (key) {
            let newKey = underline(key);
            if (newKey !== key) {
                obj[newKey] = obj[key];
                delete obj[key];
            }
            jsonNewline(obj[newKey]);
        });
    }
}

function jsonline(obj: any): void {
    if (Array.isArray(obj)) {
        obj.forEach(function (v) {
            jsonline(v);
        });
    } else if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach(function (key) {
            let newKey = humpline(key);
            if (newKey !== key) {
                obj[newKey] = obj[key];
                delete obj[key];
            }
            jsonline(obj[newKey]);
        });
    }
}

const formatDate = (date: number | string, format: string = "YYYY-MM-DD"): string => {
    if (!date) {
        return "";
    }
    let time = typeof date === 'string' ? parseInt(date, 10) : date;
    
    // 处理10位时间戳
    if (time < 99999999) {
        const str = time.toString();
        if (str.length >= 8) {
            const year = str.substring(0, 4);
            const month = str.substring(4, 6);
            const day = str.substring(6, 8);
            time = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10)).getTime() / 1000;
        }
    }
    return dayjs.unix(time).format(format);
}

// 下载量格式化
const bigNumFormat = (num: number | string): string => {
    let numStr = num + "";
    if (!numStr.includes(".")) {
        numStr += ".";
    }
    return numStr
        .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
            return $1 + ",";
        })
        .replace(/\.$/, "");
};

export default {
    jsonNewDate: function (obj: any): void {
        jsonNewline(obj);
    },
    jsonNewLineData: function (obj: any): void {
        jsonline(obj);
    },
};

export {
    formatDate,
    bigNumFormat
};